/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CreateDeviceRemoteActionDto,
  DeviceRemoteActionsControllerCreateV1PathParameters,
  DeviceRemoteActionsControllerDeleteV1PathParameters,
  DeviceRemoteActionsControllerFindAllV1Params,
  DeviceRemoteActionsControllerFindAllV1PathParameters,
  DeviceRemoteActionsControllerFindOneV1PathParameters,
  DeviceRemoteActionsControllerUpdateV1PathParameters,
  UpdateDeviceRemoteActionDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DeviceRemoteActionsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Create a new device remote action
   */

  create<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DeviceRemoteActionsControllerCreateV1PathParameters,
    createDeviceRemoteActionDto: CreateDeviceRemoteActionDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/device-remote-actions`, createDeviceRemoteActionDto);
  }
  /**
   * @summary Get all device remote actions for a client
   */

  findAll<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DeviceRemoteActionsControllerFindAllV1PathParameters,
    params?: DeviceRemoteActionsControllerFindAllV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/device-remote-actions`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * @summary Get a specific device remote action by ID
   */

  findOne<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    id,
  }: DeviceRemoteActionsControllerFindOneV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/device-remote-actions/${id}`);
  }
  /**
   * @summary Update a specific device remote action
   */

  update<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: DeviceRemoteActionsControllerUpdateV1PathParameters,
    updateDeviceRemoteActionDto: UpdateDeviceRemoteActionDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/devices/v1/clients/${clientId}/device-remote-actions/${id}`, updateDeviceRemoteActionDto);
  }
  /**
   * @summary Delete a specific device remote action
   */

  delete<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    id,
  }: DeviceRemoteActionsControllerDeleteV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/device-remote-actions/${id}`);
  }
}
